/* OWN (Stoffeya): close the fabric zoom with a tap — phones only.
 *
 * Dawn's ModalDialog closes the media modal on `pointerup` only when
 * `pointerType === 'mouse'` (assets/global.js), so on a phone the × button was
 * the only way out — and since the photo fills the screen
 * (assets/stoffeya-product-zoom.css) there is no background left to tap.
 *
 * Touch is tracked with touch events rather than pointer events: on iOS a tap
 * that follows a scroll does not always produce a usable pointerup, but the
 * synthesized `click` is reliable. So: remember whether the finger moved or a
 * second finger joined, and close on `click` only when it was a clean tap.
 * Dragging to pan and pinching to zoom keep the photo open, and the mouse
 * behaviour on desktop is left to Dawn.
 */
(function () {
  var MOVE_TOLERANCE = 12; // px of finger travel that still counts as a tap

  function wire(modal) {
    if (modal.dataset.stoffeyaTapClose) return;
    modal.dataset.stoffeyaTapClose = 'true';

    var moved = false;
    var startX = 0;
    var startY = 0;
    var touched = false;

    modal.addEventListener(
      'touchstart',
      function (event) {
        touched = true;
        moved = event.touches.length > 1; // a pinch is never a tap
        startX = event.touches[0].clientX;
        startY = event.touches[0].clientY;
      },
      { passive: true }
    );

    modal.addEventListener(
      'touchmove',
      function (event) {
        if (event.touches.length > 1) {
          moved = true;
          return;
        }
        var travel =
          Math.abs(event.touches[0].clientX - startX) + Math.abs(event.touches[0].clientY - startY);
        if (travel > MOVE_TOLERANCE) moved = true;
      },
      { passive: true }
    );

    modal.addEventListener('click', function (event) {
      if (!touched) return; // mouse clicks stay with Dawn
      if (!modal.hasAttribute('open')) return;
      if (moved) return;
      if (event.target.closest('button, a, deferred-media, product-model')) return;

      if (typeof modal.hide === 'function') modal.hide();
    });
  }

  function init() {
    document.querySelectorAll('product-modal').forEach(wire);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
